import { combineReducers } from "redux";
import cashInOutReducer from "./cash-in-out/cash-in-out-reducer";
import reducer from "./general/reducer";

const rootReducer = combineReducers({
  cashInOut: cashInOutReducer,
  general: reducer,
});

export default rootReducer;
